/**
 * Base Message Constants
 * Core constants used across all message modules
 */

/**
 * Message Priority Levels
 */
export const MESSAGE_PRIORITY = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
};

/**
 * Message Security Levels
 */
export const MESSAGE_SECURITY_LEVELS = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  CONFIDENTIAL: 'CONFIDENTIAL',
  CRITICAL: 'CRITICAL'
};

/**
 * Message Status States
 */
export const MESSAGE_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  READ: 'READ',
  FAILED: 'FAILED',
  ARCHIVED: 'ARCHIVED'
};

/**
 * Message Sender/Recipient Roles
 */
export const MESSAGE_ROLES = {
  VOICE_ACTOR: 'VOICE_ACTOR',
  BOOK_CREATOR: 'BOOK_CREATOR',
  ADMIN: 'ADMIN',
  SYSTEM: 'SYSTEM',
  PLATFORM: 'PLATFORM'
};

/**
 * Message Direction Flow
 */
export const MESSAGE_FLOW = {
  VOICE_ACTOR_TO_BOOK_CREATOR: 'VOICE_ACTOR_TO_BOOK_CREATOR',
  BOOK_CREATOR_TO_VOICE_ACTOR: 'BOOK_CREATOR_TO_VOICE_ACTOR',
  BIDIRECTIONAL: 'BIDIRECTIONAL',
  SYSTEM_TO_USER: 'SYSTEM_TO_USER'
};

/**
 * Business Hours Configuration
 * Defines time restrictions for different message types
 */
export const MESSAGE_BUSINESS_HOURS = {
  STANDARD: {
    startHour: 6,
    endHour: 22,
    weekdaysOnly: true,
    timezone: 'America/Los_Angeles'
  },
  FINANCIAL: {
    startHour: 8,
    endHour: 18,
    weekdaysOnly: true,
    timezone: 'America/New_York'
  },
  ALWAYS_AVAILABLE: {
    startHour: 0,
    endHour: 24,
    weekdaysOnly: false,
    timezone: 'UTC'
  }
};

const baseMessageConstants = {
  MESSAGE_PRIORITY,
  MESSAGE_SECURITY_LEVELS,
  MESSAGE_STATUS,
  MESSAGE_ROLES,
  MESSAGE_FLOW,
  MESSAGE_BUSINESS_HOURS
};

export default baseMessageConstants;
